<!--关于我们-->
<template>
  <div class="main">
    <!--    头部-->
    <div class="header">
      <Header
        :headerMenuSelectedKey="headerMenuSelectedKey"
        :shrinkMenuSelectedKey="subMenuSelectedKey"/>
    </div>
    <!--    banner图-->
    <div class="banner">
      <div class="item">
        <img :src="dataList[currentIndex]">
      </div>
      <div class="page" v-if="this.dataList.length > 1">
        <ul>
          <ul>
            <li @click="gotoPrev" class="pre">&lt;</li>
            <li @click="gotoNext" class="next">&gt;</li>
          </ul>
        </ul>
      </div>
    </div>
    <!--    企业微信-->
    <div class="enterpriseWechat">
      <EnterpriseWechat/>
    </div>
    <!--    内容-->
    <div class="content">
      <!--      关于我们-->
      <div class="about-us">
        <h1>关于我们</h1>
        <div class="line">
          <div class="line-left"></div>
          <div class="line-right"></div>
        </div>
        <div class="about-us-left">
          <img src="static/image/about/aboutUs.jpg" class="about-us-left-img"/>
          <div>
            <p>
              福玳，由在医疗健康和消费品创意领域4A公司服务多年的设计总监、数字媒体负责人、著名IT公司的资深工程师和数据科学家共同创立于上海。专注为医疗健康和消费品企业提供数字化的创意和医学服务。目前，福玳是多家世界著名和本土领先医疗健康多元化公司的合作伙伴，福玳为他们提供全方位的数字媒体创意支持，帮助他们更好的聚焦核心业务、宣传推广关键品牌、助力新品上市、掌握市场动向。福玳在数字健康领域也颇有建树，为多家合作伙伴提供了令人耳目一新的数字化程序（App）开发和用户体验与用户互动界面（UX/UI）优化的相关服务。
              <br><br>
              随着生物医药健康领域创新公司的异军突起，福玳也成功的为多家IPO前和已经上市的创新公司提供了专项的数字媒体运营管理服务，助力这些新企业聚焦核心业务、提升估值，优化路演，福玳与这些崭露头角的新颖公司携手一同向前快速发展！
            </p>
          </div>
        </div>
      </div>
      <!--      我们的成长-->
      <div class="grow-up">
        <h1>我们的成长</h1>
        <div class="line">
          <div class="line-left"></div>
          <div class="line-right"></div>
        </div>
        <div class="contact-img">
          <div class="contact-img-tel">
            <img src="static/image/icon/kehu.png" class="img-icon"/>
            <h2>20+</h2>
            <p>世界知名品牌客户</p>
          </div>
          <div class="contact-img-tel">
            <img src="static/image/icon/day.png" class="img-icon"/>
            <h2>100+</h2>
            <p>超过6年成立时间</p>
          </div>
          <div class="contact-img-tel">
            <img src="static/image/icon/project.png" class="img-icon"/>
            <h2>1000+</h2>
            <p>总项目完成数</p>
          </div>
          <div class="contact-img-tel">
            <img src="static/image/icon/huojiang.png" class="img-icon"/>
            <h2>100+</h2>
            <p>品牌满意口碑</p>
          </div>
        </div>
      </div>
    </div>
    <!--    尾部-->
    <div class="footer">
      <Footer/>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header";
import Footer from "../components/Footer";
import EnterpriseWechat from "../components/EnterpriseWechat";

export default {
  components: {Header, Footer, EnterpriseWechat},
  data() {
    return {
      visible: false,
      selectLabel: '',
      headerMenuSelectedKey: 'about',
      subMenuSelectedKey: '',
      dataList: ["static/image/about/banner1.jpg", "static/image/about/banner2.jpg"],
      currentIndex: 0,   //默认显示图片
    }
  },
  mounted() {
    this.gotoPage()
  },
  methods: {
    gotoPrev() {
      this.currentIndex--;
    },
    gotoNext() {
      this.currentIndex++;
      if (this.currentIndex == this.dataList.length) {
        this.currentIndex = 0;
      }
    },
    gotoPage() {
      setInterval(() => {
        this.gotoNext()
      }, 3000)
    },
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}

.main {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: rgba(249, 249, 249, 1);
}

.header {
  width: 1920px;
  height: 60px;

}

.enterpriseWechat {
  position: fixed;
  top: 45%;
  right: 0;
}

.banner {
  width: 1920px;
  margin: 0 auto;
  position: relative;
}

.banner img {
  width: 100%;
  display: block;
}

.banner .page {
  /*background: rgba(0, 0, 0, .5);*/
  color: #ffffff;
  letter-spacing: 20px;
  position: absolute;
  right: 0;
  bottom: 50%;
  width: 100%;
}

.banner .page ul {
  display: flex;
  justify-content: center;
  align-content: center;
}

.pre {
  position: absolute;
  left: 10px;
  font-size: 30px;
}

.next {
  position: absolute;
  right: 10px;
  font-size: 30px;
}


.content {
  width: 1400px;
  height: auto;
}

.contact-img {
  width: 1400px;
  height: 300px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 50px;
}

.contact-img-tel {
  width: 22%;
  height: 300px;
  background: #ffffff;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.img-icon {
  width: 50px;
  height: 50px;
  margin: 30px 35px;
}

.contact-img-tel h2 {
  font-weight: bold;
  font-size: 52px;
  color: #000000;
}

.contact-img-tel p {
  font-size: 22px;
  color: #000000;
}

.about-us {
  width: 100%;
  height: 600px;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 50px;
}

h1 {
  color: #D1121C;
  font-size: 34px;
  text-align: center;
}
.line {
  margin-top: 20px;
}

.line-left {
  width: 37px;
  height: 8px;
  background: #D1121C;
  border-radius: 10px;
  float: left;
}

.line-right {
  width: 119px;
  height: 8px;
  background: #D1121C;
  border-radius: 10px;
  float: left;
  margin-left: 10px;
}

.about-us-left {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: start;
  margin-top: 50px;
}

.about-us-left-img {
  width: 631px;
  height: 371px;
}

.about-us-left p {
  font-size: 20px;
  margin-left: 50px;
}

.grow-up {
  width: 100%;
  height: 600px;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 50px;
}

.about-img {
  width: 1269px;
  height: 308px;
  margin-top: 50px;
}

.footer {
  height: 189px;
  width: 1920px;
  overflow: hidden;
  position: relative;
  bottom: 0;
}


</style>





// WEBPACK FOOTER //
// src/views/About.vue